const KEY = "nv_cookie_consent";
export const CONSENT_EVENT = "nv-cookie-settings";
export const CONSENT_SAVED = "nv-cookie-saved";
const PH_KEY = "phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP";
const PH_METHODS = "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric";

const loaded = { posthog: false, ga: false };
let gaId = "";

// Google Analytics 4 de la web pública. NUNCA se carga sin consentimiento de medición:
// hasta que el visitante acepte, no se descarga gtag ni se crea ninguna cookie _ga.
function loadGa() {
  if (loaded.ga || !gaId || !getConsent()?.medicion) return false;
  loaded.ga = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", gaId, { anonymize_ip: true }); // envía la primera página vista
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
  document.head.appendChild(s);
  return true;
}

// Guarda el ID de GA4 de los ajustes SEO y lo carga solo si ya hay consentimiento.
// Devuelve true si acaba de cargarlo (en ese caso la página vista ya se ha enviado).
export function configurarAnalitica(id) {
  const limpio = typeof id === "string" && /^G-[A-Z0-9]+$/i.test(id.trim()) ? id.trim() : "";
  if (limpio !== gaId && !loaded.ga) gaId = limpio;
  return loadGa();
}

// Página vista en la navegación interna; no hace nada si GA no está cargado (sin consentimiento).
export function paginaVista(ruta) {
  if (!loaded.ga || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: ruta, page_location: window.location.href, page_title: document.title });
}

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && c.v === 1 ? c : null;
  } catch {
    return null;
  }
}

function loadPosthog() {
  if (loaded.posthog) return;
  loaded.posthog = true;
  const ph = window.posthog || [];
  if (!ph.__SV) {
    window.posthog = ph;
    ph._i = [];
    ph.init = function (i, s, a) {
      const g = (t, e) => {
        const o = e.split(".");
        if (o.length === 2) { t = t[o[0]]; e = o[1]; }
        t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      const p = document.createElement("script");
      p.type = "text/javascript";
      p.crossOrigin = "anonymous";
      p.async = true;
      p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js";
      document.head.appendChild(p);
      let u = ph;
      if (a !== undefined) u = ph[a] = []; else a = "posthog";
      u.people = u.people || [];
      u.toString = (x) => { let e = "posthog"; if (a !== "posthog") e += "." + a; if (!x) e += " (stub)"; return e; };
      u.people.toString = () => u.toString(1) + ".people (stub)";
      PH_METHODS.split(" ").forEach((m) => g(u, m));
      ph._i.push([i, s, a]);
    };
    ph.__SV = 1;
  }
  window.posthog.init(PH_KEY, {
    api_host: "https://ap.emergent.sh",
    person_profiles: "identified_only",
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false, maskAllInputs: true, maskTextSelector: ".ph-mask" },
  });
}

function purge(prefixes) {
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => prefixes.some((p) => n.startsWith(p)))
    .forEach((n) => { document.cookie = `${n}=; Max-Age=0; path=/`; document.cookie = `${n}=; Max-Age=0; path=/; domain=.${window.location.hostname}`; });
  Object.keys(localStorage).filter((k) => prefixes.some((p) => k.startsWith(p))).forEach((k) => localStorage.removeItem(k));
}

export function applyConsent(c) {
  if (c?.medicion) { loadPosthog(); loadGa(); }
}

export function saveConsent(prefs) {
  const c = { v: 1, funcionalidad: true, preferencias: !!prefs.preferencias, marketing: !!prefs.marketing, medicion: !!prefs.medicion, fecha: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new Event(CONSENT_SAVED));
  const revocaPh = (loaded.posthog || loaded.ga) && !c.medicion;
  if (!c.medicion) {
    if (loaded.posthog) window.posthog?.opt_out_capturing?.();
    if (gaId) window[`ga-disable-${gaId}`] = true;
    purge(["ph_", "__ph", "_ga", "_gid", "_gat"]);
  }
  if (revocaPh) { window.location.reload(); return c; }
  applyConsent(c);
  return c;
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(CONSENT_EVENT));
}
